// Vendor
import 'bootstrap-datepicker'
import moment from 'moment'
import escapeHtml from '../../utils/sanitize'

// Filtering Flow Functions
function buildPostJson (data) {
  const postJson = {
    criteria: data
  }

  return JSON.stringify(postJson)
}

function fetchResults (data, filterSetKeyPrefix, enabledSuccessHandle = true) {
  postFilters(refreshPath, filters, filterSetKeyPrefix, function (results) {
    if (enabledSuccessHandle) {
      handleFilterResponse(results)
      localStorage.setItem(filterSetKeyPrefix + '_filters', JSON.stringify(filters))
      const event = new Event('FilterResultsUpdated')
      document.dispatchEvent(event)
    }
  })
}

/**
 * @param results
 */
function handleFilterResponse (results) {
  if (results.redirect != undefined) {
    window.location.href = results.redirect
  }

  $('.resultsContainer').html(results.results)
  $('.paginationContainer').each(function () {
    $(this).html(results.pagination)
  })

  if (results.modals) {
    $('#raven-eye-modals-container').html(results.modals)
  }

  $('.resultsContainer').css('opacity', '1')
  $('.paginationContainer').each(function () {
    $(this).css('opacity', '1')
  })

  updateUIFilters()

  if (results.isPageOutOfRangeReload) {
    $('#page-out-of-range-reload').removeClass('d-none')
  }
}

function updateUIFilters () {
  Object.keys(filters).map(key => {
    if (key.includes('_filters')) {
      let filterLogsList = ''
      if (filters[key].logs) {
        filterLogsList = Object.keys(filters[key].logs).join(', ')
      }

      let filterPermissionGroupList = ''
      if (filters[key].permission_groups) {
        filterPermissionGroupList = Object.keys(filters[key].permission_groups).join(', ')
      }

      let filterNotificationGroupList = ''
      if (filters[key].notification_groups) {
        filterNotificationGroupList = Object.keys(filters[key].notification_groups).join(', ')
      }

      let filterPrioritiesList = ''
      if (filters[key].priorities) {
        filterPrioritiesList = Object.keys(filters[key].priorities).join(', ')
      }

      let filterCategoriesList = ''
      if (filters[key].categories) {
        filterCategoriesList = Object.keys(filters[key].categories).join(', ')
      }

      let filterLocationsList = ''
      if (filters[key].locations) {
        filterLocationsList = Object.keys(filters[key].locations).join(', ')
      }

      let filterRecordType = ''
      if (filters[key].record_type) {
        filterRecordType = filters[key].record_type
      }

      let filterIssueStatuesList = ''
      if (filters[key].issue_statuses) {
        filterIssueStatuesList = Object.keys(filters[key].issue_statuses).join(', ')
      }

      let filterSMSThreadStatusList = ''
      if (filters[key].sms_thread_status) {
        filterSMSThreadStatusList = Object.keys(filters[key].sms_thread_status).join(', ')
      }

      const filterHideDisabled = filters[key].hide_disabled

      if (filterIssueStatuesList != '') {
        $('#issue-status-filterContainer').fadeIn()
        $('#issue-status-filterValues').html(escapeHtml(filterIssueStatuesList))
      } else {
        $('#issue-status-filterContainer').fadeOut()
      }

      // Record Status Filtering
      const filterActiveStatuses = filters[key].active_status
      const filterInActiveStatuses = filters[key].inactive_status

      if (filterActiveStatuses && filterInActiveStatuses) {
        $('#status-filterContainer').fadeIn()
        $('#status-filterValues').html('Active, Inactive')
      } else if (filterActiveStatuses) {
        $('#status-filterContainer').fadeIn()
        $('#status-filterValues').html('Active')
      } else if (filterInActiveStatuses) {
        $('#status-filterContainer').fadeIn()
        $('#status-filterValues').html('Inactive')
      } else {
        $('#status-filterContainer').fadeOut()
      }

      const filterShowIncompleteOnly = filters[key].show_incomplete_only
      let filterFromDate = ''
      let filterToDate = ''

      if (filters[key].from_date != '' && filters[key].from_date != undefined) {
        filterFromDate = moment.unix(filters[key].from_date).format(accountDateFormat.toUpperCase())
      }

      if (filters[key].to_date != '' && filters[key].to_date != undefined) {
        filterToDate = moment.unix(filters[key].to_date).format(accountDateFormat.toUpperCase())
      }

      if (filterLogsList != '') {
        $('#logs-filterContainer').fadeIn()
        $('#logs-filterValues').html(escapeHtml(filterLogsList))
      } else {
        $('#logs-filterContainer').fadeOut()
      }

      if (filterPermissionGroupList != '') {
        $('#permission_groups-filterContainer').fadeIn()
        $('#permission_groups-filterValues').html(escapeHtml(filterPermissionGroupList))
      } else {
        $('#permission_groups-filterContainer').fadeOut()
      }

      if (filterNotificationGroupList != '') {
        $('#notification_groups-filterContainer').fadeIn()
        $('#notification_groups-filterValues').html(escapeHtml(filterNotificationGroupList))
      } else {
        $('#notification_groups-filterContainer').fadeOut()
      }

      if (filterPrioritiesList != '') {
        $('#priorities-filterContainer').fadeIn()
        $('#priorities-filterValues').html(escapeHtml(filterPrioritiesList))
      } else {
        $('#priorities-filterContainer').fadeOut()
      }

      if (filterCategoriesList != '') {
        $('#categories-filterContainer').fadeIn()
        $('#categories-filterValues').html(escapeHtml(filterCategoriesList))
      } else {
        $('#categories-filterContainer').fadeOut()
      }

      if (filterFromDate != '') {
        $('#from-date-filterContainer').fadeIn()
        $('#from-date-filterValues').html(escapeHtml(filterFromDate))
      } else {
        $('#from-date-filterContainer').fadeOut()
      }

      if (filterToDate != '') {
        $('#to-date-filterContainer').fadeIn()
        $('#to-date-filterValues').html(escapeHtml(filterToDate))
      } else {
        $('#to-date-filterContainer').fadeOut()
      }

      if (filterRecordType != '') {
        $('#record-type-filterContainer').fadeIn()
        $('#record-type-filterValues').html(escapeHtml(filterRecordType))
      } else {
        $('#record-type-filterContainer').fadeOut()
      }

      if (filterLocationsList != '') {
        $('#locations-filterContainer').fadeIn()
        $('#locations-filterValues').html(escapeHtml(filterLocationsList))
      } else {
        $('#locations-filterContainer').fadeOut()
      }

      if (filterShowIncompleteOnly) {
        $('#show-incomplete-only-filterContainer').fadeIn()
      } else {
        $('#show-incomplete-only-filterContainer').fadeOut()
      }

      if (filterHideDisabled) {
        $('#hide_disabled-filterContainer').fadeIn()
      } else {
        $('#hide_disabled-filterContainer').fadeOut()
      }

      if (filterSMSThreadStatusList != '') {
        $('#sms-thread-status-filterContainer').fadeIn()
        $('#sms-thread-status-filterValues').html(escapeHtml(filterSMSThreadStatusList))
      } else {
        $('#sms-thread-status-filterContainer').fadeOut()
      }
    }
  })

  $('#loadingIcon').hide()
}

function clearAllFilters (postUrl, filterSetKeyPrefix, filters, isActiveFiltering = true) {
  clearLocalFilters(filterSetKeyPrefix)
  clearUIFilters()
  // post cleared filters

  if (isActiveFiltering) {
    fetchResults(
      buildPostJson(filters), filterSetKeyPrefix
    )
  }
}

function clearLocalFilters (filterSetKeyPrefix) {
  $('#from-date').datepicker('clearDates')
  $('#to-date').datepicker('clearDates')

  // Record Based Filters
  filters[filterSetKeyPrefix + '_filters'].from_date = null
  filters[filterSetKeyPrefix + '_filters'].to_date = null
  filters[filterSetKeyPrefix + '_filters'].logs = {}
  filters[filterSetKeyPrefix + '_filters'].record_type = null
  filters[filterSetKeyPrefix + '_filters'].active_status = null
  filters[filterSetKeyPrefix + '_filters'].inactive_status = null

  // issue based filters
  filters[filterSetKeyPrefix + '_filters'].statuses = {}
  filters[filterSetKeyPrefix + '_filters'].priorities = {}
  filters[filterSetKeyPrefix + '_filters'].categories = {}
  filters[filterSetKeyPrefix + '_filters'].locations = {}
  filters[filterSetKeyPrefix + '_filters'].show_incomplete_only = false

  // user based filters
  filters[filterSetKeyPrefix + '_filters'].permission_groups = {}
  filters[filterSetKeyPrefix + '_filters'].sms_thread_status = {}

  filters[filterSetKeyPrefix + '_search'] = null

  return filters
}

function clearUIFilters () {
  $('#from-date').datepicker('clearDates')
  $('#to-date').datepicker('clearDates')
  if ($('#incomplete-issue-toggle').length > 0) {
    $('#incomplete-issue-toggle').checkbox('set unchecked')
  }

  $('.ui.fluid.multiple.search.selection.dropdown#issue_status').dropdown('clear')
  $('.ui.fluid.multiple.search.selection.dropdown#record_status').dropdown('clear')
  $('.ui.fluid.multiple.search.selection.dropdown#priorities').dropdown('clear')
  $('.ui.fluid.multiple.search.selection.dropdown#logs').dropdown('clear')
  $('.ui.fluid.multiple.search.selection.dropdown#categories').dropdown('clear')
  $('.ui.fluid.search.selection.dropdown#record_type').dropdown('clear')
  $('.ui.fluid.search.selection.dropdown#permission_groups').dropdown('clear')
  $('.ui.fluid.search.selection.dropdown#notification_groups').dropdown('clear')
  $('.ui.fluid.search.selection.dropdown#locations').dropdown('clear')
  $('.ui.fluid.search.selection.dropdown#sms_thread_status').dropdown('clear')

  $('.search-input').val('')
}

function postFilters (url, filters, filterSetKeyPrefix, successCallback) {
  $('#loadingIcon').show()
  $('.resultsContainer').css('opacity', '0.1')
  $('.paginationContainer').each(function () {
    $(this).css('opacity', '0.1')
  })

  filters.filter_set_key_prefix = filterSetKeyPrefix

  $.ajax({
    type: 'POST',
    url: url,
    data: buildPostJson(filters),

    success: successCallback
  })
}

function handlePageLimit (filterSetKeyPrefix, limit) {
  $('#loadingIcon').show()

  filters[filterSetKeyPrefix + '_filters'].page_limit = parseInt(limit)

  fetchResults(
    buildPostJson(filters), filterSetKeyPrefix
  )
}

function handlePagination (filterSetKeyPrefix, page) {
  $('#loadingIcon').show()

  filters[filterSetKeyPrefix + '_filters'].page = page

  fetchResults(
    buildPostJson(filters), filterSetKeyPrefix
  )
}

export {
  buildPostJson,
  fetchResults,
  handleFilterResponse,
  clearAllFilters,
  clearLocalFilters,
  updateUIFilters,
  postFilters,
  handlePageLimit,
  handlePagination
}
